import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"

import Twitter from "../Icon/Twitter"
import Facebook from "../Icon/Facebook"
import Pinterest from "../Icon/Pinterest"
import styles from "./SocialShare.module.scss"
import { sendGTMEvent } from "../../utils/googleAnalytics"

const SocialShare = ({ shareText, shareUrl, className, color }) => {
    const [isClient, setIsClient] = useState(false)

    useEffect(() => {
        setIsClient(true)
    }, [])

    return (
        <React.Fragment key={isClient}>
            <div className={`${styles.shareContainer} ${className || ""}`}>
                <a
                    href={`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}&quote=${shareText}&t=${shareText}`}
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    onClick={() =>
                        sendGTMEvent("widget share click", `facebook`)
                    }
                >
                    <div className={styles.icon}>
                        <Facebook color={color} />
                    </div>
                </a>
                <a
                    href={`https://twitter.com/intent/tweet?text=${shareText}&url=${shareUrl}`}
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    onClick={() =>
                        sendGTMEvent("widget share click", `twitter`)
                    }
                >
                    <div className={styles.icon}>
                        <Twitter color={color} />
                    </div>
                </a>
                <a
                    href={`https://pinterest.com/pin/create/button/?url=${shareUrl}&description=${shareText}`}
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    onClick={() =>
                        sendGTMEvent("widget share click", `pinterest`)
                    }
                >
                    <div className={styles.icon}>
                        <Pinterest color={color} />
                    </div>
                </a>
            </div>
        </React.Fragment>
    )
}

SocialShare.defaultProps = {
    className: "",
    color: "#000",
}

SocialShare.propTypes = {
    shareText: PropTypes.string.isRequired,
    shareUrl: PropTypes.string.isRequired,
    className: PropTypes.string,
    color: PropTypes.string,
}

export default SocialShare
